import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from '@mui/material';
import cn from 'src/taskpane/utility/bem';
import * as APP_CONSTANTS from 'src/taskpane/shared/Constants';
import { getOfficeThemeStyle } from 'src/taskpane/shared/styles';
import ActionImage from 'src/taskpane/shared/ActionImage';
import './styles.scss';

const className = cn('action-role-container');
const el = (name, mod) => cn(className, name, mod);

const ActionRoleContainer = ({
    actionChoice,
    handleActionRoleChange,
}) => {
    const radioButtonStyle = {
        height: '36px',
        width: '36px',
        padding: '8px',
        margin: '0 20px 0 0',
        color: getOfficeThemeStyle('--border-color-gray'),
        '&.Mui-checked': { color: getOfficeThemeStyle('--light-primary') },
    };

    return (
        <div className={className}>
            <div className={el('description')}> Which system do you use? </div>
            <div className={el('radio-group')}>
                <div className={el('radio-option')}>
                    <Radio
                        name="radio-buttons"
                        sx={radioButtonStyle}
                        value={APP_CONSTANTS.ACTION_ROLE.ECM}
                        checked={actionChoice === APP_CONSTANTS.ACTION_ROLE.ECM}
                        onChange={handleActionRoleChange}
                        inputProps={{ 'aria-label': APP_CONSTANTS.ACTION_ROLE.ECM }}
                    />
                    <ActionImage actionType={APP_CONSTANTS.ACTION_ROLE.ECM} />
                </div>
                <div className={el('radio-option')}>
                    <Radio
                        name="radio-buttons"
                        sx={radioButtonStyle}
                        value={APP_CONSTANTS.ACTION_ROLE.PROJECT}
                        checked={actionChoice === APP_CONSTANTS.ACTION_ROLE.PROJECT}
                        onChange={handleActionRoleChange}
                        inputProps={{ 'aria-label': APP_CONSTANTS.ACTION_ROLE.PROJECT }}
                        id="pm"
                    />
                    <ActionImage actionType={APP_CONSTANTS.ACTION_ROLE.PROJECT} />
                </div>
            </div>
        </div>);
};

ActionRoleContainer.propTypes = {
    actionChoice: PropTypes.string.isRequired,
    handleActionRoleChange: PropTypes.func.isRequired,
};

export default ActionRoleContainer;
